import { FC } from 'react';

import { Page } from '../../components';

export const ActionLists: FC = () => {
  return (
    <Page title="Action List">
      <br />
      Action Lists page.
      <br />
    </Page>
  );
};
